<template>
  <aside
    class="wt-scanning-eye"
    :class="{ '-visible': visible }"
    :style="{ position: position }"
  >
    <div class="-eye" />
  </aside>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'fixed',
      validator(value) {
        return ['fixed', 'absolute'].includes(value);
      },
    },
  },
};
</script>
